import React, { useState, useEffect } from "react";
import "./mobilemenu.css";
import { Link } from "react-router-dom"
import Educationsvg from "../Mobilesvgs/Educationsvg";
import Publicationsvg from "../Mobilesvgs/Publicationsvg";
import Certificatesvg from "../Mobilesvgs/Certificatesvg";
import Extrasvg from "../Mobilesvgs/Extrasvg";
import Worksvg from "../Mobilesvgs/Worksvg";
import Homesvg from "../Mobilesvgs/Homesvg";
import Settingsvg from "../Mobilesvgs/Settingsvg";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined';
import EventNoteIcon from '@material-ui/icons/EventNote';
import EmojiEventsOutlinedIcon from '@material-ui/icons/EmojiEventsOutlined';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { decode } from "base-64";
import Cookies from "universal-cookie";
import { AcademicCapIcon, BadgeCheckIcon, BookOpenIcon, BriefcaseIcon, PresentationChartLineIcon, PuzzleIcon,CogIcon,HomeIcon } from '@heroicons/react/outline';

const cookies = new Cookies();
function MobileMenu({ setIsMenuOpen, isMenuOpen }) {
    if (cookies.get("wmusers")) {
        var user = decode(cookies.get("wmusers"));
    } else {
        var user = 'members';
    }
    const [checkMenu, setCheckMenu] = useState(false)
    const menuToggle = () => {
        setCheckMenu(true)
        if (!checkMenu) {
            setIsMenuOpen(false)
            setCheckMenu(false)
        }
    }
    useEffect(() => {
        setTimeout(() => { setCheckMenu(isMenuOpen) }, 10000)
    }, [])
    return (
        <>
            <nav className="menu">
                <input type="checkbox" checked={isMenuOpen} href="#" className="expandmenu" name="expandmenu" id="expandmenu" onChange={() => menuToggle()} />
                <label className="expandmenu-button" htmlFor="expandmenu">
                    <span className="lines first-line"></span>
                    <span className="lines sec-line"></span>
                    <span className="lines third-line"></span>
                </label>

                <Link to={user === 'members' ? "/education"  : "/i/institute"} className="menu-item col1" style={{ backgroundColor: "var(--color-5)" }} onClick={() => {setIsMenuOpen(false); {user !== 'members' && alert('This Feature is only available in desktop version')}}}>
                    <div className="w-full h-full flex items-center justify-center">
                        {user === 'members' ? <AcademicCapIcon className="w-6" />  : <EmojiEventsOutlinedIcon fill={"#ffffff"} />}
                    </div>
                </Link>
                <Link to={user === 'members' ? "/publication"  : "/i/institute/managenotices"} className="menu-item col2" style={{ backgroundColor: "var(--color-5)" }} onClick={() => setIsMenuOpen(false)}>
                    <div className="w-full h-full flex items-center justify-center">
                        {user === 'members' ? <BookOpenIcon className="w-6" />  : <EventNoteIcon fill={"#ffffff"} />}
                    </div>
                </Link>
                <Link to="/certificate" className="menu-item col3" style={{ backgroundColor: "var(--color-5)" }} onClick={() => setIsMenuOpen(false)}>
                    {" "}
                    <div className="w-full h-full flex items-center justify-center">
                        {user === 'members' ? <BadgeCheckIcon className="w-6" />  : <VerifiedUserIcon fill={"#ffffff"} />}
                    </div>{" "}
                </Link>
                <Link to={user === 'members' ? "/extracurriculam"  : "/i/institute/manageusers"} certificate className="menu-item col4" style={{ backgroundColor: "var(--color-5)" }} onClick={() => setIsMenuOpen(false)}>
                    {" "}
                    <div className="w-full h-full flex items-center justify-center">
                        {user === 'members' ? <PuzzleIcon className="w-6" />  : <SupervisorAccountOutlinedIcon fill={"#ffffff"} />}
                    </div>{" "}
                </Link>
                <Link to={user === 'members' ? "/workexperience"  : "/i/institute"} className="menu-item col5" style={{ backgroundColor: "var(--color-5)" }} onClick={() => setIsMenuOpen(false)}>
                    {" "}
                    <div className="w-full h-full flex items-center justify-center">
                        {user === 'members' ? <BriefcaseIcon className="w-6" />  : <HomeIcon className="w-6" />}
                    </div>{" "}
                </Link>
                <Link to={user === 'members' ? "/Project"  : "/account"} className="menu-item col6" style={{ backgroundColor: "var(--color-5)" }} onClick={() => setIsMenuOpen(false)}>
                    {" "}
                    <div className="w-full h-full flex items-center justify-center">
                        {user === 'members' ? <PresentationChartLineIcon className="w-6" />  : <CogIcon className="w-6"/>}
                    </div>{" "}
                </Link>
            </nav>
        </>
    );
}

export default MobileMenu;
